import { css } from '@emotion/react'
import { SelectMenuItem, SelectMenuItemProps, Text, Theme, useTheme } from 'bold-ui'
import { Fragment } from 'react'

export interface RenderGrupoSelectHeaderProps {
  titulo: string
  emptyMessage?: string | false
  itemProps: Omit<SelectMenuItemProps, 'style'>
}

export function RenderGrupoSelectHeader(props: Readonly<RenderGrupoSelectHeaderProps>) {
  const { titulo, emptyMessage, itemProps } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Fragment>
      <SelectMenuItem style={styles.headerItem} {...itemProps}>
        <Text fontWeight='bold' style={styles.headerItemText}>
          {titulo}
        </Text>
      </SelectMenuItem>
      {emptyMessage && (
        <SelectMenuItem style={styles.disabledItem} {...itemProps}>
          <Text>{emptyMessage}</Text>
        </SelectMenuItem>
      )}
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  headerItem: css`
    pointer-events: none;
    cursor: not-allowed;
    background-color: ${theme.pallete.primary.c90};
  `,
  headerItemText: css`
    color: ${theme.pallete.primary.c40};
  `,
  disabledItem: css`
    pointer-events: none;
    cursor: not-allowed;
  `,
})
